module.exports = __webpack_public_path__ + "img/jjooJuventud.fab6775a.jpg";